module.exports = "/images/vendor/flag-icon-css/flags/1x1/tf.svg?2e7dc1af2d97ea62c34756b7f838fa77";